/**
 * Branding Configuration Composable
 * Centralized branding configuration using environment variables
 */

import { computed } from 'vue'

export function useBranding() {
  // App Information
  const appName = computed(() => import.meta.env.VITE_APP_NAME || 'DhanDo')
  const appFullName = computed(() => import.meta.env.VITE_APP_FULL_NAME || 'DhanDo POS')
  const appTagline = computed(() => import.meta.env.VITE_APP_TAGLINE || 'Point of Sale System')
  const appVersion = computed(() => import.meta.env.VITE_APP_VERSION || '1.0.0')
  const appDescription = computed(() => 
    import.meta.env.VITE_APP_DESCRIPTION || 
    'Mobile Point of Sale system for businesses with thermal printing, inventory management, and billing'
  )

  // Developer Information
  const developerName = computed(() => import.meta.env.VITE_DEVELOPER_NAME || 'TechWithin')
  const developerWebsite = computed(() => import.meta.env.VITE_DEVELOPER_WEBSITE || 'https://techwithin.in')
  const supportEmail = computed(() => import.meta.env.VITE_SUPPORT_EMAIL || 'contact@techwithin.com')
  const supportPhone = computed(() => import.meta.env.VITE_SUPPORT_PHONE || '+91-8766599646')

  // Copyright Information
  const copyrightYear = computed(() => import.meta.env.VITE_COPYRIGHT_YEAR || '2025')
  const copyrightHolder = computed(() => import.meta.env.VITE_COPYRIGHT_HOLDER || 'TechWithin')
  // const copyrightText = computed(() => `© ${copyrightYear.value} ${copyrightHolder.value}`)
  const copyrightText = computed(() => `© ${copyrightYear.value}`)

  // Theme Configuration
  const themeColor = computed(() => import.meta.env.VITE_THEME_COLOR || '#2563eb')
  const backgroundColor = computed(() => import.meta.env.VITE_BACKGROUND_COLOR || '#f9fafb')

  // Business Configuration
  const defaultBusinessName = computed(() => import.meta.env.VITE_DEFAULT_BUSINESS_NAME || 'DhanDo Store')
  const businessType = computed(() => import.meta.env.VITE_BUSINESS_TYPE || 'Point of Sale')

  // Computed Branding Strings
  const fullAppTitle = computed(() => `${appFullName.value} v${appVersion.value}`)
  const poweredByText = computed(() => `Powered by ${appFullName.value}`)
  const craftedByText = computed(() => `Crafted By ${developerName.value}`)
  const appInstallTitle = computed(() => `Install ${appFullName.value}`)
  const appUpdateTitle = computed(() => `${appName.value} Update Available`)

  // Meta Information for SEO/PWA
  const metaTitle = computed(() => appFullName.value)
  const metaDescription = computed(() => appDescription.value)
  const appleTouchTitle = computed(() => appFullName.value)

  // Support Information
  const supportInfo = computed(() => ({
    email: supportEmail.value,
    phone: supportPhone.value,
    website: developerWebsite.value,
    developer: developerName.value
  }))

  // Theme Configuration Object
  const themeConfig = computed(() => ({
    primary: themeColor.value,
    background: backgroundColor.value
  }))

  return {
    // Basic App Info
    appName,
    appFullName,
    appTagline,
    appVersion,
    appDescription,

    // Developer Info
    developerName,
    developerWebsite,
    supportEmail,
    supportPhone,

    // Copyright
    copyrightYear,
    copyrightHolder,
    copyrightText,

    // Theme
    themeColor,
    backgroundColor,
    themeConfig,

    // Business
    defaultBusinessName,
    businessType,

    // Computed Strings
    fullAppTitle,
    poweredByText,
    craftedByText,
    appInstallTitle,
    appUpdateTitle,

    // Meta Info
    metaTitle,
    metaDescription,
    appleTouchTitle,

    // Support
    supportInfo
  }
}